import {
  AlertType,
  Tkv2OrderAttachmentBody,
  isDefined,
  nonDismissibleAlertTypes,
} from '@aloft/toolkit-shared';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AlertsState, SyncResult } from '../types.ts';
import { clearOrder } from './actions/clearOrder.ts';
import { getBumpedSyncState } from './utils/getBumpedSyncState.ts';

export const initialAlertsState: AlertsState = {
  dismissedAlerts: [],
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState: initialAlertsState,
  reducers: {
    dismissAlert: (state, action: PayloadAction<AlertType>) => {
      // Prevent dismissing non-dismissable alerts
      if (nonDismissibleAlertTypes.includes(action.payload)) return;
      if (state.dismissedAlerts.includes(action.payload)) return;

      Object.assign(state, {
        dismissedAlerts: [...state.dismissedAlerts, action.payload],
        syncState: getBumpedSyncState(state.syncState),
      });
    },
    cancelDismissAlert: (state, action: PayloadAction<AlertType>) => {
      if (!state.dismissedAlerts.includes(action.payload)) return;

      Object.assign(state, {
        dismissedAlerts: state.dismissedAlerts.filter((alert) => alert !== action.payload),
        syncState: getBumpedSyncState(state.syncState),
      });
    },
    setAlerts: (state, action: PayloadAction<Tkv2OrderAttachmentBody<'alerts'>>) => {
      Object.assign(state, {
        ...action.payload,
      });
    },
    alertsMutationComplete(state, action: PayloadAction<SyncResult>) {
      const { payload } = action;
      const { status } = payload;

      if (isDefined(state.syncState)) {
        Object.assign(state.syncState, { status });

        if (status === 'success') {
          Object.assign(state.syncState, { serverRevision: payload.serverRevision });
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearOrder, () => initialAlertsState);
  },
});

export const { dismissAlert, cancelDismissAlert, setAlerts, alertsMutationComplete } =
  alertsSlice.actions;

export const alertsReducer = alertsSlice.reducer;
